import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ff109da0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "dropdown-item-checkbox__label" };
import { ElCheckbox, ElDropdownItem } from "element-plus";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DropdownItemCheckbox',
    props: {
        iconClass: {},
        label: {},
        modelValue: { type: Boolean },
        isLoading: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const toggle = () => {
            modelValueProxy.value = !modelValueProxy.value;
        };
        const modelValueProxy = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit("update:modelValue", value);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDropdownItem), null, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(["dropdown-item-checkbox", {
                                'dropdown-item-checkbox--checked': modelValueProxy.value,
                            }]),
                        onClick: _withModifiers(toggle, ["stop"])
                    }, [
                        (_ctx.iconClass)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(_ctx.iconClass)
                            }, null, 2 /* CLASS */))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1 /* TEXT */),
                        _createVNode(_unref(ElCheckbox), {
                            indeterminate: _ctx.isLoading,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                            modelValue: modelValueProxy.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((modelValueProxy).value = $event))
                        }, null, 8 /* PROPS */, ["indeterminate", "modelValue"])
                    ], 2 /* CLASS */)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
